import { render, staticRenderFns } from "./SuperiorityBlock.vue?vue&type=template&id=2e04d131&"
import script from "./SuperiorityBlock.vue?vue&type=script&lang=js&"
export * from "./SuperiorityBlock.vue?vue&type=script&lang=js&"
import style0 from "./SuperiorityBlock.vue?vue&type=style&index=0&id=2e04d131&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports